import React from 'react';
import { cx } from 'linaria';
import { styled } from 'linaria/react';
import { RedTilt } from './RedTilt';
import { theme } from '../Theme';

const BadgeWrapper = styled('div')`
  width: 100%;
  height: 100%;

  &.product-page-badge {
    display: flex;

    > div {
      position: relative;

      .content {
        padding: 4px 14px;
        font-size: ${theme.fontSizes.button};

        ${theme.below.lg} {
          padding: 0px 4px;
          font-size: ${theme.fontSizes.paragraph};
        }
      }
    }
  }
`;
const BadgeStyle = styled('div')`
  position: absolute;
  z-index: 1;
`;
const BadgeTopLeftWrapper = styled(BadgeStyle)`
  top: 0px;
  left: 0px;
`;
const BadgeTopRightWrapper = styled(BadgeStyle)`
  top: 0px;
  right: 0px;
`;
const BadgeBottomLeftWrapper = styled(BadgeStyle)`
  bottom: 0px;
  left: 0px;
`;
const BadgeBottomRightWrapper = styled(BadgeStyle)`
  bottom: 0px;
  right: 0px;
`;
const ProductBadgeComponent = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  &.with-badge span {
    position: absolute;
    z-index: 1;
  }
`;
const Badge = ({ badge }) => {
  return React.createElement(
    ProductBadgeComponent,
    { className: cx(badge.style, badge.url && 'with-badge') },
    React.createElement(RedTilt, null, badge.text),
    badge.url &&
      React.createElement('img', {
        width: '70',
        height: '70',
        src: badge.url,
        alt: badge.name
      })
  );
};
const StyledBadges = ({ badges = [], isProductPage }) => {
  if (badges.length === 0) return null;
  const topLeftBadges = badges.filter(badge => badge.location === 'TOP_LEFT');
  const topRightBadges = badges.filter(badge => badge.location === 'TOP_RIGHT');
  const bottomLeftBadges = badges.filter(
    badge => badge.location === 'BOTTOM_LEFT'
  );
  const bottomRightBadges = badges.filter(
    badge => badge.location === 'BOTTOM_RIGHT'
  );
  return React.createElement(
    BadgeWrapper,
    { className: isProductPage ? 'product-page-badge' : '' },
    topLeftBadges.length > 0 &&
      React.createElement(
        BadgeTopLeftWrapper,
        { className: 'badge-top-left' },
        topLeftBadges.map(badge =>
          React.createElement(Badge, { key: badge.name, badge: badge })
        )
      ),
    topRightBadges.length > 0 &&
      React.createElement(
        BadgeTopRightWrapper,
        { className: 'badge-top-right' },
        topRightBadges.map(badge =>
          React.createElement(Badge, { key: badge.name, badge: badge })
        )
      ),
    bottomLeftBadges.length > 0 &&
      React.createElement(
        BadgeBottomLeftWrapper,
        { className: 'badge-bottom-left' },
        bottomLeftBadges.map(badge =>
          React.createElement(Badge, { key: badge.name, badge: badge })
        )
      ),
    bottomRightBadges.length > 0 &&
      React.createElement(
        BadgeBottomRightWrapper,
        { className: 'badge-bottom-right' },
        bottomRightBadges.map(badge =>
          React.createElement(Badge, { key: badge.name, badge: badge })
        )
      )
  );
};
export default StyledBadges;
